import WindowSillsInstallationInformation from "./WindowSillsInstallationInformation";

export default WindowSillsInstallationInformation